<template>
   <section>
      <v-container fluid class="">
         <!-- Header -->
         <ControlHeader :pageData="pageData" :showCreate="false" :valid="true" />
         <!-- End Of Header -->

         <ShiftsContent :report="report" :print-static-data="printStaticData" :page-data="pageData"
            :print-template-type="printTemplateType" />
      </v-container>
   </section>
</template>

<script>
import ShiftsContent from "./ShiftsContent.vue";
export default {
   name: "ShiftsControl",
   components: {
      ShiftsContent,
   },
   data: () => ({
      pageData: {
         screen_code: "06-020",
         url: null,
         controlRoute: "/sales/list_shifts-control/",
         entityName: null,
         main: null,
         category: null,
         isLoading: false,
         isEdit: false,
         editIsLoading: false,
      },
      report: {},
      printStaticData: {},
      printTemplateType: null,
   }),
   mounted() {
      this.pageMainData();
      this.getData();
   },
   methods: {
      pageMainData() {
         this.pageData.main = this.$global.FilterPermissions(this.pageData.screen_code).main_title;
         this.pageData.category = this.$global.FilterPermissions(this.pageData.screen_code).cat_title;
         this.pageData.url = this.$global.FilterPermissions(this.pageData.screen_code).url;
         this.pageData.entityName = this.$global.FilterPermissions(
            this.pageData.screen_code
         ).sub_title;
      },
      getData() {
         if (this.$global.CheckAction(this.pageData.screen_code, 1)) {
            this.viewForm = true;
            this.pageData.isLoading = true;
            this.$api.GET_METHOD(`shift/${this.$route.params.id}`).then((response) => {
               this.pageData.isLoading = false;
               if (response.check) {
                  this.report = response.data.data;
                  this.printStaticData = response.data.print || {};
                  this.printTemplateType = response.data?.print?.temp || "temp_1";
               }
            });
         } else {
            this.$router.push("/");
         }
      },
   },
};
</script>
